<template>
  <div class="infomation main_top">
    <div class="guid">
        <div class="guide_item flex_col_center" style="padding:0 16px;">
            <div class="item_logo"><img :src="logo" alt=""></div>
            <!-- <div class="item_msg">{{ $t('key118') }}</div> -->
            <div class="item_banner"></div>
            <div class="item_btnGroup">
                <div class="item_btn">
                    <div class="flex_center btn" @click="toPage('/agreement')">
                        <!-- <a class="flex_center btn" href="https://www.playsave.gg/agreement"> -->
                            <div class="icon_money flex_center"><svg t="1731913805077" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3247" width="16" height="16"><path d="M511.948915 948.524259C271.549927 948.524259 76.642184 753.605568 76.642184 513.105627 76.642184 272.616632 271.549927 77.710105 511.948915 77.710105c240.501158 0 435.408901 194.907743 435.408901 435.395522 0 240.499942-194.907743 435.418632-435.408901 435.418632z m0-802.01596c-202.469548 0-366.596111 164.127779-366.596111 366.597328s164.126563 366.596111 366.596111 366.596111c202.570502 0 366.709228-164.126563 366.709228-366.596111 0-202.470765-164.13751-366.597327-366.709228-366.597328z" p-id="3248" fill="#1f2128"></path><path d="M640.028887 644.592486c-6.222647 15.139422-14.927784 27.782974-26.116628 38.131347-11.186412 10.274178-24.558534 18.140061-40.099338 23.530751-15.538372 5.384608-32.749172 8.079953-51.700512 8.079954-26.527741 0-52.543415-5.0708-78.029994-15.45323-25.490228-10.244987-48.704738-25.991348-69.626503-47.325442l45.278391-61.047861c15.854613 14.513022 32.224942 26.114195 49.006383 34.718378 16.681704 8.594453 35.022457 12.945197 54.917654 12.945198 15.850964 0 28.292608-3.312015 36.997746-9.847254 8.807307-6.523075 13.259005-15.639326 13.259005-27.143194v-1.139683c0-5.597463-0.928045-10.562444-2.798731-14.815884-1.867037-4.367773-5.277573-8.392545-10.461491-12.130269-5.176619-3.713397-12.327311-7.449904-21.448426-11.186411-9.117467-3.73894-21.032448-7.677355-35.645208-11.803081-17.624345-4.780102-33.577479-10.262015-47.877647-16.167205-14.300167-6.023172-26.419489-13.370906-36.364047-22.176997-9.946991-8.807307-17.725299-19.69329-23.216943-32.737008-5.495293-13.159268-8.180907-29.438373-8.180908-48.805692v-1.143333c0-17.934505 2.899685-34.091979 8.909478-48.501614 5.906406-14.399905 14.199214-26.730865 24.869909-37.203302 10.774082-10.459058 23.521021-18.537795 38.335688-24.142555 14.925351-5.586516 31.293247-8.381599 49.216805-8.381599 25.487795 0 48.905429 4.251007 70.355072 12.841811 21.346257 8.6054 41.041979 20.93636 58.863367 37.00626l-39.797693 65.062903c-15.539588-12.018368-30.767801-21.449643-45.698017-28.29869-14.914404-6.935405-29.838539-10.448111-44.752944-10.44811-14.925351 0-26.112979 3.310798-33.576263 9.84482-7.463284 6.521859-11.19006 14.702766-11.190061 24.333516v1.156712c0 6.420905 1.1409 11.901602 3.211061 16.581967 2.171115 4.651173 6.110746 8.791495 11.815244 12.529219 5.592598 3.837461 13.361175 7.3526 23.10261 10.674344 9.847253 3.425132 22.175781 7.36233 37.202086 11.817677 17.612182 5.166889 33.256373 11.084241 47.038392 17.607317 13.886622 6.525508 25.487795 14.399905 34.922719 23.521021 9.531012 9.230584 16.680488 19.892765 21.44721 32.221292 4.867676 12.343123 7.247997 27.145627 7.247997 44.352778v1.142116c0.003649 19.377049-3.105242 36.671774-9.415463 51.799033zM476.100583 366.901405v-105.896894h73.46518v105.896894h-73.46518z m0 398.217763v-106.011228h73.46518v106.011228h-73.46518z" p-id="3249" fill="#1f2128"></path></svg></div>
                            <div>{{ $t('key117') }}</div>
                        <!-- </a> -->
                       
                    </div>
                    <img src="../../assets/image/hand.png" alt="" class="hand" >
                </div>
            </div>
        </div>
        <div class="guide_item program_group">
            <div class="program_item">
                <div class="item_title">{{ $t('key119') }}</div>
            </div>
            <div class="program_item flex program_item_head">
            <div class="item_third">{{ $t('key113') }}</div>
            <div class="item_third">{{ $t('key119') }}</div>
            <div class="item_third">{{ $t('key121') }}</div>
            </div>
            <div class="program_item flex">
            <div class="item_third"><span class="text_info">Te****es</span></div>
            <div class="item_third"><span class="text_info">6737</span></div>
            <div class="item_third"><span class="text_price">$15470</span></div>
            </div>
            <div class="program_item flex">
            <div class="item_third"><span class="text_info">Do**ks</span></div>
            <div class="item_third"><span class="text_info">2849</span></div>
            <div class="item_third"><span class="text_price">$6588</span></div>
            </div>
            <div class="program_item flex">
            <div class="item_third"><span class="text_info">U1070633615</span></div>
            <div class="item_third"><span class="text_info">2973</span></div>
            <div class="item_third"><span class="text_price">$4487</span></div>
            </div>
        </div>
        <div v-html="content"></div>
        <!-- <div class="guide_item program_group">
            <div class="program_item">
                <div class="item_title">playsave.com {{ $t('key34') }} {{ $t('key38') }}</div>
            </div>
            <div class="plan_container grid">
                <div class="grid_md_4 grid_xs_12 plan_item flex_col_start">
                    <div class="item_img"><img src="https://domino-1320917288.cos.ap-jakarta.myqcloud.com/play-save/play_2025010316224542196.png" alt=""></div>
                    <div class="item_name">{{ $t('key122') }}</div>
                    <div class="item_info">
                        <p>{{ $t('key123') }}</p>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 plan_item flex_col_start">
                    <div class="item_img"><img src="https://domino-1320917288.cos.ap-jakarta.myqcloud.com/play-save/play_2025010316240588489.png" alt=""></div>
                    <div class="item_name">{{ $t('key124') }}</div>
                    <div class="item_info">  
                        <p>{{ $t('key125') }}</p>
                        <p>*{{ $t('key126') }}</p>
                        <p>*{{ $t('key127') }}</p>
                        <p>*{{ $t('key128') }}</p>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 plan_item flex_col_start">
                    <div class="item_img"><img src="https://domino-1320917288.cos.ap-jakarta.myqcloud.com/play-save/play_2025010316244259652.png" alt=""></div>
                    <div class="item_name">{{ $t('key129') }}</div>
                    <div class="item_info">
                        <p>1. {{ $t('key130') }}</p>
                        <p>2. {{ $t('key131') }}</p>
                        <p>3. {{ $t('key132') }}</p>
                    </div>  
                </div>
            </div>
        </div> -->
    </div>
    
  </div>
</template>

<script>
import {serveMixins} from '../../mixins/serveMixins.js'
export default {
    mixins:[serveMixins],
    data(){
        return{

        }
    },
    created(){
      
    },
    methods:{
        toPage(path){
            let serveList = this.$store.state.serveList
            let langId = this.$store.state.lang.dictValue
            
            serveList.map(v=>{
                console.log('serveList',v.remark)
                if(v.language == langId && v.remark == path ){
                    let lang = localStorage.getItem('lang')
                    this.$router.push(path+'/'+lang+'/'+v.id)
                }
            })
            
        }


    },
   
    computed:{
        logo(){ return this.$store.state.logo },
        localName(){return this.$store.state.localName}
    }
}
</script>

<style lang="scss" scoped>
.guide_item{
    // background-color: #ffffff10;
    .item_logo{
        width:150px;
        padding-top:16px;
    }
    .item_msg{
        font-size: 15px;
        line-height: 18px;
        // color:#5e626b;
        margin-top:16px;
        padding-bottom:16px;
    }
    .item_banner{
        height: 260px;
        background: url('../../assets/image/guid_head.png') no-repeat 50%;
        background-size: auto 100%;
        width: 100%;
    }
    .item_btnGroup{
        padding: 16px 16px 29px;
        .item_btn{
            position: relative;
            margin: 0 auto;
            width: 343px;
            height: 48px;
            box-shadow:0px 4px -1px rgba(0, 0, 0, .1), 0px 0px 5px 0px rgba(0, 0, 0, .08), 0px 0px 10px 0px rgba(0, 0, 0, .05);
            .btn{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                background: #ffd633;
                border-radius: 4px;
                cursor: pointer;
                font-weight: 600;
                .icon_money{
                    margin-right:6px;
                }
            }
            .hand{
                position: absolute;
                right: 20%;
                bottom: -15px;
                width: 46px;
                height: 46px;
                animation: handScale 1.5s ease-in-out infinite;
            }
            @keyframes handScale {
                0% {
                    transform: scale(1);
                }

                50% {
                    transform: scale(1.3) translate(20%, 28%);
                }
                100% {
                    transform: scale(1);
                }
            }
        }
    }
}

@media screen and (max-width:768px){
    .item_btnGroup{
        // background:#fff;
        background-color: #ffffff10;
        position: fixed;
        bottom:0;
        left:0;
        right: 0;
        .item_btn{
            width: 100%!important;
        }
    }
}

</style>